import { removeModal, showModal } from './actions';
import Modals from './Modals';
import reducer from './reducer';
import { makeAction } from './utils';

export { makeAction, reducer, removeModal, showModal };

export default Modals;
